<template>
    <v-select
            v-model="model"
            :items="data"
            :label="label"
            :loading="loading"
            :search-input.sync="search"
            clearable
            deletable-chips
            item-value="id"
            item-text="name"
            color="primary"
            :placeholder="$t('inputs.shared.startTypingToSearch')"
    />
</template>

<script>
    export default {
        name: "choose-project",
        props: ['label', 'value'],
        data() {
            return {
                isEditing: false,
                loading: false,
                model: this.value,
                search: null,
                data: [],
                cached: []
            }
        },
        mounted() {
            this.loading = true;
            const params = new URLSearchParams();
            params.append('perPage', "50");
            this.axios.get(this.api.ACTIONS.PROJECT, {params})
                .then(res => {
                    this.data = res.data.data.data
                })
                .catch(err => console.log(err))
                .finally(() => this.loading = false);
        },
        watch: {
            model(val) {
                if (val)
                    this.$emit("input", integer(val));
                else this.$emit('input', integer(val));
            }
        }
    }
</script>

<style scoped>

</style>
